import { render } from "./SteeringIcon.vue?vue&type=template&id=2c89e56e"
const script = {}

import exportComponent from "C:\\laragon\\www\\carzoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__